import React, { useContext, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { visaInfos } from '../api';
import { AuthContext } from '../context/AuthContext';
import { ISalesIndividualVisaInfo } from '../utils/types';
import { CircularProgress, Box, Alert } from '@mui/material';
import { pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();

type VisaContainerProps = {
  salesIndividualId: string;
};

export function VisaContainer({ salesIndividualId }: VisaContainerProps) {
  const [result, setResult] = useState<ISalesIndividualVisaInfo[]>([]);
  const { token } = useContext(AuthContext);
  const { t } = useTranslation();
  const [, setError] = useState<string>();
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    fetchVisaInfos(salesIndividualId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [salesIndividualId]);

  const fetchVisaInfos = async (id: string) => {
    try {
      const res = await visaInfos(id, token);
      const data = await res.json();
      if (res?.status === 200) {
        setResult(data);
      } else {
        throw data;
      }
    } catch (e: any) {
      setError(e.detail || t('loginPage.registerErrorMessage'));
    } finally {
      setLoading(false);
    }
  };

  const iframeRef = useRef<HTMLIFrameElement>(null);

  return (
    <Box>
      {loading && <CircularProgress color="secondary" />}
      {result.length > 0 && result[0].visaDocFileFullPath ? (
        <iframe
          ref={iframeRef}
          title="document provider"
          src={
            `https://mozilla.github.io/pdf.js/web/viewer.html?file=${result[0]?.visaDocFileFullPath}` ||
            ''
          }
          style={{
            width: '100%',
            height: 'calc(100vh - 184px)',
            border: 'none',
          }}
        />
      ) : (
        !loading && <Alert severity="info">{t('visaContainer.noRecord')}</Alert>
      )}
    </Box>
  );
}
